let time_spent = 0;
let time_spent_id = null;

const processDataToSubmit = (
	user_data, strategy, question, total_questions, mock_id,
	time_spent, remaining_time, skip, submit_section, currentQuestion,
	test_pending
) => {

	const obj2 = makeResultObject(user_data, strategy);
	const obj1 = finalObjectCreation(obj2, question);
	const final_data = finalSubmit(
		obj1,
		question,
		total_questions,
		mock_id,
		time_spent,
		remaining_time,
		skip,
		submit_section,
		currentQuestion,
		test_pending
	);

	return final_data;
};

const finalSubmit = (
	obj1, question, total_questions, mock_id, time_spent, remaining_time, skip,
	submit_section,	currentQuestion, test_pending
) => {
	let curr = question;

	let obj = [];
	obj.push(obj1);

	let finalArr = [];

	let bodyFormData = new FormData();
	bodyFormData.append('q_count', total_questions);
	bodyFormData.append('mock_id', mock_id);
	bodyFormData.append('q_time', time_spent);
	bodyFormData.append('complete', markComplete(submit_section, skip, question.question_number, total_questions));
	bodyFormData.append('question_number', question.question_number);
	bodyFormData.append('pending', test_pending);
	bodyFormData.append('curr_q', submit_section ? 0 : (currentQuestion + 1));
	bodyFormData.append('time', remaining_time);
	bodyFormData.append('response[]', true);
	bodyFormData.append('device', 'website');

	if (submit_section) {
		bodyFormData.append('skip', skip);
	}
	
	if ([1, 2, 3, 4, 5, 21, 22].includes(obj1.type)) {
		bodyFormData = appendSpeakingData(obj1, bodyFormData);

	} else if ([6, 7].includes(obj1.type)) {
		bodyFormData = appendWritingData(obj1, bodyFormData);

	} else if ([8, 9, 10, 11, 12].includes(obj1.type)) {
		bodyFormData = appendReadingData(obj1, bodyFormData);

	} else if ([13, 14, 15, 16, 17, 18, 19, 20].includes(obj1.type)) {
		bodyFormData = appendListeningData(obj1, bodyFormData);

	}

	return bodyFormData;
};

const markComplete = (submit_section, skip, questionNumber, totalQuestions) => {
	return ((skip > 2 && submit_section) || (questionNumber === totalQuestions)) ? 1 : 0;
}

const appendListeningData = (v, bodyFormData) => {
	bodyFormData.append('text[]', v.answer);
	bodyFormData.append('selected[]', v.text_answer);
	bodyFormData.append('type[]', v.type);
	bodyFormData.append('answer[]', v.correct);
	bodyFormData.append('lang[]', v.lang);
	bodyFormData.append('script[]', v.script);
	bodyFormData.append('ans[]', v.q_ans);
	bodyFormData.append('correct[]', v.correct);
	bodyFormData.append('length[]', v.length);
	bodyFormData.append('html[]', v.html);
	bodyFormData.append('audio_text[]', v.audio_text);
	bodyFormData.append('text_answer[]', v.text_answer);
	bodyFormData.append('id[]', v.id);
	bodyFormData.append('file[]',  v.data);
	bodyFormData.append('q_ans[]', v.q_ans);
	bodyFormData.append('duration[]', v.duration);

	return bodyFormData;
};

const appendReadingData = (v, bodyFormData) => {
	bodyFormData.append('text[]', v.answer);
	bodyFormData.append('selected[]', v.text_answer);
	bodyFormData.append('type[]', v.type);
	bodyFormData.append('lang[]', v.lang);
	bodyFormData.append('text_answer[]', v.text_answer);
	bodyFormData.append('answer[]', v.correct);
	bodyFormData.append('script[]', v.script);
	bodyFormData.append('correct[]', v.correct);
	bodyFormData.append('ans[]', v.q_ans);
	bodyFormData.append('length[]', v.length);
	bodyFormData.append('id[]', v.id);
	bodyFormData.append('audio_text[]', v.audio_text);
	bodyFormData.append('html[]', v.html);
	bodyFormData.append('file[]',  v.data);
	bodyFormData.append('q_ans[]', v.q_ans);
	bodyFormData.append('duration[]', v.duration);

	return bodyFormData;
};

const appendWritingData = (v, bodyFormData) => {
	bodyFormData.append('text[]', v.answer);
	bodyFormData.append('text_answer[]', v.text_answer);
	bodyFormData.append('selected[]', v.text_answer);
	bodyFormData.append('type[]', v.type);
	bodyFormData.append('audio_text[]', v.audio_text);
	bodyFormData.append('answer[]', v.q_ans);
	bodyFormData.append('script[]', v.script);
	bodyFormData.append('ans[]', v.q_ans);
	bodyFormData.append('lang[]', v.lang);
	bodyFormData.append('html[]', v.html);
	bodyFormData.append('file[]',  v.data);
	bodyFormData.append('correct[]', v.correct);
	bodyFormData.append('length[]', v.length);
	bodyFormData.append('id[]', v.id);
	bodyFormData.append('q_ans[]', v.q_ans);
	bodyFormData.append('duration[]', v.duration);

	return bodyFormData;
};

const appendSpeakingData = (v, bodyFormData) => {
	bodyFormData.append('text[]', v.answer);
	bodyFormData.append('selected[]', v.text_answer);
	bodyFormData.append('text_answer[]', v.text_answer);
	bodyFormData.append('answer[]', v.ans);
	bodyFormData.append('lang[]', v.lang);
	bodyFormData.append('html[]', v.html);
	bodyFormData.append('audio_text[]', v.audio_text);
	bodyFormData.append('q_ans[]', v.q_ans);
	bodyFormData.append('length[]', v.length);
	bodyFormData.append('ans[]', v.q_ans);
	bodyFormData.append('duration[]', v.duration);
	bodyFormData.append('file[]', v.data);
	bodyFormData.append('type[]', v.type);
	bodyFormData.append('correct[]', v.correct);
	bodyFormData.append('script[]', v.script);
	bodyFormData.append('id[]', v.id);

	if (parseInt(v.type) === 1) {
		bodyFormData.set('strategy', v.strategy);
	}
	
	return bodyFormData;
};

const makeResultObject = (obj, strategy) => {
	return {
		data: obj.data,
		text_answer: obj.answer,
		length: obj.length,
		correct: obj.correct,
		second: obj.time,
		lang: obj.lang,
		html: obj.html,
		audio_text: obj.audio_text,
		duration: obj.duration,
		strategy,
    };
};

const finalObjectCreation = (obj1 = false, question) => {    
	let obj = {};
	if (obj1) {
		obj = {
			...obj1,
			type: question.subcategory_id,
			id: question.id,
			response: true,
			answer: question.question,
			script: question.audio_script,
			q_ans: question.answer
		}
	} else {
		// obj = {
		// 	...result,
		// 	type: qdata.subcategory_id,
		// 	id: qdata.id,
		// 	response: response,
		// 	answer: qdata.question,
		// 	script: qdata.audio_script,
		// 	q_ans: qdata.answer
		// }
		obj = obj1; // this is temp.
	}
	return obj;
};

const questionTime = () => {
	time_spent = 0;
	clearInterval(time_spent_id);

	time_spent_id = setInterval(() => {
		time_spent += 1;
	}, 1000);
};

export {
	processDataToSubmit,
	questionTime,
	time_spent
};